import React, { useEffect, useMemo } from 'react';
import { Container, CoverAppImageContainer, CoverAppLink, CoverImage, CoverImageText } from './styles';
import { VinculosAPI } from '../../http-requests';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpinnerConstructor } from '../index';
import { sanitizeImageUrl } from '../../utils/urlSanitizer';
import Axios from 'axios';
import { connect } from 'react-redux';
import { StyleHelper } from '../../helpers/StyleHelper';

const AppCover = (props) => {


    const
        {
    codAcervo,
        src,
        altSrc,
        title,
        textColor = '#ffffff',
        link = undefined,
        width = '168px',
        height = '237px' ,
         onClick,
         selected  = undefined
        } = props;

    const [imageSrc, setImageSrc] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const triedAltRef = React.useRef(false);

    // Simple in-memory cache shared across component instances for vinculos images
    // Key: codAcervo, Value: Array of image URLs
    // Pending promises map prevents duplicate requests in parallel
    // We place these on module scope via React ref trick to avoid re-creation per render
    const cacheRef = React.useRef();
    if (!cacheRef.current) {
        cacheRef.current = {
            vinculosCache: new Map(),
            vinculosPending: new Map(),
        };
    }

    const handleImageError = () => {
        // If we haven't tried the altSrc yet and altSrc is provided, try it once.
        if (!triedAltRef.current && altSrc) {
            triedAltRef.current = true;
            setImageSrc(altSrc);
        } else {
            // Either we already tried altSrc or there's no altSrc: show title fallback
            setImageSrc(null);
        }
    };



    useEffect(() => {
        // reset alt fallback attempt whenever src changes
        triedAltRef.current = false;
        const cancelTokenSrc = Axios.CancelToken.source();
        const { token } = cancelTokenSrc;

        (async() => {
            // link_capa pode vir só com espaços do banco: trata como sem capa
            // para que o altSrc (capa padrão) seja usado
            if (!src || !src.trim()) {
                setImageSrc(null);
                setLoading(false);
                return;
            }

            const normalizedSrc = src.trim();

            if (normalizedSrc.toLowerCase() === 'vínculo no banco' && codAcervo !== undefined) {
                const { vinculosCache, vinculosPending } = cacheRef.current;

                // If cached, use immediately
                if (vinculosCache.has(codAcervo)) {
                    const cached = vinculosCache.get(codAcervo);
                    if (cached && cached.length > 0) setImageSrc(cached[0]);
                    setLoading(false);
                    return;
                }

                // If there's a pending request, await it
                if (vinculosPending.has(codAcervo)) {
                    try {
                        const data = await vinculosPending.get(codAcervo);
                        if (data && data.length > 0) setImageSrc(data[0]);
                    } catch (err) {
                        // ignore
                    } finally {
                        setLoading(false);
                    }
                    return;
                }

                // Otherwise, create a pending promise and store it to prevent duplicate requests
                const p = (async () => {
                    const response = await VinculosAPI.buscarImagensAcervo(
                        codAcervo,
                        1,
                        token,
                    );
                    return response?.data || [];
                })();

                vinculosPending.set(codAcervo, p);

                try {
                    const data = await p;
                    vinculosCache.set(codAcervo, data);
                    vinculosPending.delete(codAcervo);
                    if (data && data.length > 0) setImageSrc(data[0]);
                } catch (err) {
                    vinculosPending.delete(codAcervo);
                    // swallow
                } finally {
                    setLoading(false);
                }
            } else {
                const pattern = /^[SN]/;
                setImageSrc(pattern.test(normalizedSrc) ? normalizedSrc.replace(pattern, '') : normalizedSrc);
                setLoading(false);
            }
        })();
        return () => {
            cancelTokenSrc.cancel()
        }

    }, [src, codAcervo]);


    const getTextColor = useMemo(() =>  StyleHelper.isRgb(textColor) ? `rgb(${textColor})` : textColor, [textColor] )
    const isDataImage = (value) => typeof value === 'string' && value.indexOf('data:image') === 0;

    const resolvedSrc = imageSrc !== null ? imageSrc : altSrc;
    const hasImageSource = Boolean(resolvedSrc);

    return (
        <Container
            $selected={selected}
            title={title}
            width={loading ? '168px' : width}
            height={loading ? '237px' : height}>
            {
                loading ? (
                    <div className='d-flex flex-column justify-content-center align-items-center w-100 h-100'>
                        <FontAwesomeIcon  icon="image" className="preto50 mb-1" />
                        <SpinnerConstructor
                            grow
                            visible
                            className="preto50"
                            height={40}
                            width={40}
                        />
                    </div>
                ) : link ? (
                    <CoverAppLink to={link}>
                        {hasImageSource ? (
                            <CoverImage
                                className='img-fluid'
                                src={sanitizeImageUrl(resolvedSrc)}
                                alt={title}
                                onError={handleImageError}
                            />
                        ) : ''}
                        {
                            !hasImageSource || imageSrc === null || isDataImage(imageSrc) ? (
                                <CoverImageText $color={getTextColor}>{title}</CoverImageText>
                            ) : ''
                        }
                    </CoverAppLink>
                ) : (
                    <CoverAppImageContainer
                        onClick={() => {
                            if(onClick && typeof onClick === 'function'){
                                onClick()
                            }
                        }}
                    >
                        {hasImageSource ? (
                            <CoverImage
                                className='img-fluid'
                                src={sanitizeImageUrl(resolvedSrc)}
                                alt={title}
                                onError={handleImageError}
                            />
                        ) : ''}
                        {
                           !hasImageSource || imageSrc === null || isDataImage(imageSrc) ? (
                                <CoverImageText $color={getTextColor}>{title}</CoverImageText>
                            ) : ''
                        }
                    </CoverAppImageContainer>
                )
            }
        </Container>
    )
}


function mapStateToProps(state) {
    return {
        instituicaoRx: state.instituicao.data,
    };
}

export default connect(mapStateToProps)(AppCover);
